import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login";
import "./App.css";
import ProtectedRoute from "./middleware/ProtectedRoute";
import Home from "./Pages/Home";
import ReplaceFile from "./components/ReplaceFile";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  console.log("ENV:", process.env.REACT_APP_API_URL);

  return (
    <Router basename="/reminder">
      <Header />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<ProtectedRoute element={<Home />} />} />
        <Route
          path="/replace-file/:id"
          element={<ProtectedRoute element={<ReplaceFile />} />}
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
